import './order-tag.scss'

import cn from '../../../../commons/src/libs/class-names'

import {CommonProps, Overwrite} from '../../../../commons/src/types'

import bankNoteIcon from '../../../../commons/src/assets/icons/bank-note.svg'
import coinsHandIcon from '../../../../commons/src/assets/icons/coins-hand.svg'
import fileAttachmentIcon from '../../../../commons/src/assets/icons/file-attachment.svg'
import fileNoteIcon from '../../../../commons/src/assets/icons/file-note.svg'
import infillIcon from '../../../../commons/src/assets/icons/infill.svg'
import rulerIcon from '../../../../commons/src/assets/icons/ruler.svg'
import snailIcon from '../../../../commons/src/assets/icons/snail.svg'
import targetIcon from '../../../../commons/src/assets/icons/target.svg'
import toleranceIcon from '../../../../commons/src/assets/icons/tolerance.svg'
import zapFastIcon from '../../../../commons/src/assets/icons/zap-fast.svg'
import zapIcon from '../../../../commons/src/assets/icons/zap.svg'

import Icon from '../../../../commons/src/components/icon'
import Tooltip from '../../../../commons/src/components/tooltip'
import TooltipHandler from '../../../../commons/src/components/tooltip-handler'

export type OrderTagType =
  | 'economy'
  | 'expedited'
  | 'express'
  | 'infill'
  | 'tolerance'
  | 'needsScaling'
  | 'detailsAttached'
  | 'orderNoteAttached'
  | 'hasAdditionalCost'
  | 'isManualOrder'
  | 'hasRefundRequest'

type Props = Overwrite<
  CommonProps<'span'>,
  {
    type: OrderTagType
  }
>

type TagContent = {
  iconSource: string
  tooltipContent: string
}

export const typeToTagContentMap: Record<OrderTagType, TagContent> = {
  economy: {
    iconSource: snailIcon,
    tooltipContent: 'Economy production',
  },
  expedited: {
    iconSource: zapIcon,
    tooltipContent: 'Expedited production',
  },
  express: {
    iconSource: zapFastIcon,
    tooltipContent: 'Express shipping',
  },
  infill: {
    iconSource: infillIcon,
    tooltipContent: 'Infill specified',
  },
  tolerance: {
    iconSource: toleranceIcon,
    tooltipContent: 'Tolerance specified',
  },
  needsScaling: {
    iconSource: rulerIcon,
    tooltipContent: 'Needs scaling',
  },
  detailsAttached: {
    iconSource: fileAttachmentIcon,
    tooltipContent: 'Production details attached',
  },
  orderNoteAttached: {
    iconSource: fileNoteIcon,
    tooltipContent: 'Order note attached',
  },
  hasAdditionalCost: {
    iconSource: bankNoteIcon,
    tooltipContent: 'Additional cost requested',
  },
  isManualOrder: {
    iconSource: targetIcon,
    tooltipContent: 'Manual order',
  },
  hasRefundRequest: {
    iconSource: coinsHandIcon,
    tooltipContent: 'Refund requested',
  },
}

const OrderTag = ({className, type, ...props}: Props) => (
  <TooltipHandler
    tooltip={<Tooltip appearance="dark">{typeToTagContentMap[type].tooltipContent}</Tooltip>}
  >
    <span {...props} className={cn('OrderTag', {[`type-${type}`]: !!type}, className)}>
      <Icon source={typeToTagContentMap[type].iconSource} />
    </span>
  </TooltipHandler>
)

export default OrderTag
